import React from 'react'
import {
    Grid,
    Typography,
    Card,
    List,
    ListItem,
    ListItemText,
} from '@mui/material'
import { translate } from '../i18n'
import { ProjectSplashScreenProps } from './ProjectSplashScreen.types'
import LoadingImage from '../components/LoadingImage'

function ProjectSplashScreen({ splash }: ProjectSplashScreenProps) {
    if (!splash) {
        return (
            <Typography
                variant="caption"
                textAlign="center"
                component="h6"
                sx={{ py: 2 }}
            >
                {translate('projects.splash.empty')}
            </Typography>
        )
    }

    return (
        <Grid
            container
            justifyContent="flex-start"
            justifyItems="center"
            alignContent="center"
            alignItems="center"
            spacing={2}
            sx={{ py: 2 }}
        >
            <Grid item xs={12} md={6}>
                <Card>
                    <Grid container>
                        <LoadingImage
                            variant="background"
                            path={splash.background}
                        >
                            <LoadingImage path={splash.logo} />
                        </LoadingImage>
                    </Grid>
                </Card>
            </Grid>
            <Grid item xs={12} md={6}>
                <List dense>
                    <ListItem>
                        <ListItemText
                            primary={splash.logo_size || '---'}
                            secondary={
                                translate('projects.splash.logo_size') as string
                            }
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary={splash.logo_position || '---'}
                            secondary={
                                translate(
                                    'projects.splash.logo_position'
                                ) as string
                            }
                        />
                    </ListItem>
                </List>
            </Grid>
        </Grid>
    )
}

export default ProjectSplashScreen
